export const en = {
  // navigation
  'nav.devices': 'CONNECTED DEVICES',
  'nav.noDevices': 'No mouse connected yet.',
  'nav.connect': 'Connect device',
  'nav.demo': 'Try the demo mouse',
  'nav.tools': 'TOOLS',
  'nav.tests': 'Hardware tests',
  'nav.diagnostics': 'Diagnostics',
  'nav.resources': 'RESOURCES',
  'nav.drivers': 'Driver downloads',
  'nav.support': 'Supported devices',
  'nav.home': 'Home',
  'nav.settings': 'Settings',
  'nav.github': 'Source code',
  'nav.desktop': 'Desktop app',
  'common.soon': 'soon',

  // home
  'home.eyebrow': 'Open source · No install · WebHID',
  'home.title': 'One control panel for every gaming mouse.',
  'home.sub': 'Change DPI, polling rate, lift-off and buttons straight from your browser. No vendor bloatware, no account, no telemetry — and the code is on GitHub.',
  'home.connect': 'Connect a mouse',
  'home.demo': 'Try without a mouse',
  'home.unsupported': 'Your browser does not support WebHID. Use Chrome, Edge, Opera or another Chromium-based desktop browser to connect a mouse. The demo, tests and driver downloads still work.',
  'home.f1.t': 'Performance',
  'home.f1.d': 'DPI stages, polling rate up to 8 kHz, and instant preview before you write.',
  'home.f2.t': 'Sensor tuning',
  'home.f2.d': 'Lift-off distance, angle snapping, ripple control, motion sync and debounce.',
  'home.f3.t': 'Hardware tests',
  'home.f3.d': 'Measure real polling rate, find double-click chatter and estimate true DPI.',
  'home.f4.t': 'Driver hub',
  'home.f4.d': 'Official download links for every major brand in one searchable list.',
  'home.f5.t': 'Private by design',
  'home.f5.d': 'Everything runs locally in your browser. Nothing leaves your computer.',
  'home.f6.t': 'Built to extend',
  'home.f6.d': 'Drivers are small TypeScript modules. Add your mouse and open a pull request.',
  'home.how': 'How it works',
  'home.step1': 'Plug in your mouse or its wireless receiver.',
  'home.step2': 'Click “Connect a mouse” and pick it in the browser prompt.',
  'home.step3': 'Adjust settings, preview them, then apply.',

  // device
  'device.tab.overview': 'Overview',
  'device.tab.performance': 'Performance',
  'device.tab.sensor': 'Sensor',
  'device.tab.buttons': 'Buttons',
  'device.tab.lighting': 'Lighting',
  'device.tab.profiles': 'Profiles',
  'device.disconnect': 'Disconnect',
  'device.refresh': 'Read again',
  'device.loading': 'Reading settings from the mouse…',
  'device.notFound': 'This device is no longer connected.',
  'device.pending': '{n} unsaved change(s)',
  'device.discard': 'Discard',
  'device.apply': 'Apply changes',
  'device.applying': 'Writing…',
  'device.applied': 'Settings written to the mouse.',
  'device.applyFailed': 'Could not write settings',
  'device.readFailed': 'Could not read settings',
  'device.connected': '{name} connected',
  'device.noSettings': 'This mouse has no adjustable settings in OpenGlide yet.',

  // overview
  'overview.model': 'Model',
  'overview.vendor': 'Vendor',
  'overview.ids': 'USB ID',
  'overview.firmware': 'Firmware',
  'overview.protocol': 'Protocol',
  'overview.connection': 'Connection',
  'overview.driver': 'Driver',
  'overview.battery': 'Battery',
  'overview.charging': 'charging',
  'overview.dpi': 'Current DPI',
  'overview.rate': 'Polling rate',
  'overview.stages': 'DPI stages',
  'overview.profile': 'Active profile',
  'overview.details': 'Device details',
  'overview.storage': 'Settings storage',
  'overview.onMouse': 'Stored on the mouse',
  'overview.session': 'Active until the mouse is re-plugged',
  'conn.wired': 'Wired (USB)',
  'conn.wireless': 'Wireless',
  'conn.receiver': '2.4 GHz receiver',
  'conn.bluetooth': 'Bluetooth',
  'conn.virtual': 'Virtual device',

  // performance
  'perf.dpi': 'DPI stages',
  'perf.dpiDesc': 'Click a stage to make it active. The mouse button cycles through them.',
  'perf.dpiSingle': 'Sensitivity (DPI)',
  'perf.dpiSingleDesc': 'Counts per inch reported by the sensor.',
  'perf.stage': 'Stage {n}',
  'perf.active': 'Active',
  'perf.addStage': 'Add stage',
  'perf.remove': 'Remove',
  'perf.presets': 'Common values',
  'perf.rate': 'Polling rate',
  'perf.rateDesc': 'How often the mouse reports its position. Higher is smoother but uses more CPU and battery.',
  'perf.rateHigh': 'Rates above 1000 Hz need a fast CPU and a USB port directly on the motherboard.',

  // sensor
  'sensor.title': 'Sensor',
  'sensor.desc': 'Fine-tune how the sensor tracks.',
  'sensor.lod': 'Lift-off distance',
  'sensor.lodHint': 'Height at which the sensor stops tracking when you lift the mouse.',
  'lod.Low': 'Low',
  'lod.Medium': 'Medium',
  'lod.High': 'High',
  'sensor.angle': 'Angle snapping',
  'sensor.angleHint': 'Straightens lines. Most competitive players keep it off.',
  'sensor.ripple': 'Ripple control',
  'sensor.rippleHint': 'Smooths jitter at very high DPI at the cost of slight latency.',
  'sensor.motion': 'Motion sync',
  'sensor.motionHint': 'Aligns sensor frames with USB polling for more consistent input.',
  'sensor.debounce': 'Click debounce',
  'sensor.debounceHint': 'Filters double-click chatter. Lower is faster.',
  'sensor.sleep': 'Auto sleep',
  'sensor.sleepHint': 'Idle time before a wireless mouse goes to sleep.',
  'sensor.none': 'This mouse does not expose sensor settings.',

  // buttons
  'buttons.title': 'Button assignment',
  'buttons.desc': 'Choose what each physical button does.',
  'buttons.reset': 'Restore defaults',
  'buttons.readOnlyTitle': 'Read-only.',
  'buttons.readOnly': 'These are the assignments stored on the mouse. This driver can read them but cannot change them yet.',
  'action.left-click': 'Left click',
  'action.right-click': 'Right click',
  'action.middle-click': 'Middle click',
  'action.back': 'Back',
  'action.forward': 'Forward',
  'action.dpi-up': 'DPI up',
  'action.dpi-down': 'DPI down',
  'action.dpi-cycle': 'DPI cycle',
  'action.scroll-up': 'Scroll up',
  'action.scroll-down': 'Scroll down',
  'action.profile-cycle': 'Profile cycle',
  'action.media-play': 'Play / pause',
  'action.volume-up': 'Volume up',
  'action.volume-down': 'Volume down',
  'action.disabled': 'Disabled',

  // lighting
  'light.title': 'Lighting',
  'light.desc': 'Effect, colour and brightness of the mouse LEDs.',
  'light.effect': 'Effect',
  'light.color': 'Colour',
  'light.brightness': 'Brightness',
  'light.speed': 'Speed',
  'effect.off': 'Off',
  'effect.static': 'Static',
  'effect.breathing': 'Breathing',
  'effect.spectrum': 'Spectrum',
  'effect.wave': 'Wave',

  // profiles
  'profiles.title': 'Onboard profiles',
  'profiles.desc': 'Profiles are stored on the mouse. Click one to switch.',
  'profiles.slot': 'Profile {n}',
  'profiles.backup': 'Backup & restore',
  'profiles.backupDesc': 'Save the current settings to a file or load them back — also handy for sharing configs.',
  'profiles.export': 'Export settings',
  'profiles.import': 'Import settings',
  'profiles.imported': 'Settings loaded. Review and apply them.',
  'profiles.importFailed': 'That file is not a valid OpenGlide settings file.',

  // tests
  'tests.title': 'Hardware tests',
  'tests.sub': 'These tests work with any mouse — no connection needed.',
  'tests.rate': 'Polling rate',
  'tests.rateDesc': 'Move the mouse quickly in circles inside the box.',
  'tests.rateArea': 'Move your mouse here',
  'tests.current': 'Current',
  'tests.average': 'Average',
  'tests.peak': 'Peak',
  'tests.reset': 'Reset',
  'tests.click': 'Click test',
  'tests.clickDesc': 'Click inside the pad. Clicks closer than {ms} ms apart are flagged as possible switch chatter.',
  'tests.clickArea': 'Click here',
  'tests.left': 'Left',
  'tests.right': 'Right',
  'tests.middle': 'Middle',
  'tests.back': 'Back',
  'tests.forward': 'Forward',
  'tests.chatter': 'Chatter',
  'tests.scroll': 'Scroll',
  'tests.scrollDesc': 'Scroll up and down over the pad.',
  'tests.up': 'Up',
  'tests.down': 'Down',
  'tests.dpi': 'DPI analyzer',
  'tests.dpiDesc': 'Put the mouse at a start mark, click Start, move it exactly the chosen distance to the right, then click. Disable pointer acceleration and use 1:1 OS sensitivity.',
  'tests.distance': 'Distance',
  'tests.start': 'Start',
  'tests.measuring': 'Move now, then click to stop…',
  'tests.result': 'Measured',
  'tests.counts': 'counts',

  // drivers
  'drivers.title': 'Driver downloads',
  'drivers.sub': 'Official configuration software for every major brand. Links go straight to the manufacturer — OpenGlide never re-hosts files.',
  'drivers.search': 'Search brand or software…',
  'drivers.all': 'All',
  'drivers.web': 'Web-based',
  'drivers.download': 'Official download',
  'drivers.open': 'Open web app',
  'drivers.openglide': 'Supported in OpenGlide',
  'drivers.none': 'No brands match your search.',
  'drivers.note': 'Missing a brand or a link is outdated? Open an issue or edit apps/web/src/data/drivers.ts.',

  // support
  'support.title': 'Supported devices',
  'support.sub': 'Mice that OpenGlide can talk to today. Community drivers are welcome.',
  'support.device': 'Device',
  'support.driver': 'Driver',
  'support.status': 'Status',
  'support.features': 'Features',
  'support.request': 'Request a mouse',
  'support.requestDesc': 'Connect it, open Diagnostics, and attach the HID report to a GitHub issue. That is usually enough to start a driver.',
  'support.addDriver': 'Write a driver',
  'support.search': 'Search brand or model…',
  'support.remapOnly': 'Button remapping',
  'support.count': '{n} families',
  'status.stable': 'Stable',
  'status.beta': 'Beta',
  'status.experimental': 'Experimental',
  'feature.dpi': 'DPI',
  'feature.pollingRates': 'Polling',
  'feature.liftOff': 'LOD',
  'feature.angleSnapping': 'Angle snap',
  'feature.rippleControl': 'Ripple',
  'feature.motionSync': 'Motion sync',
  'feature.debounce': 'Debounce',
  'feature.sleepTimeout': 'Sleep',
  'feature.lighting': 'RGB',
  'feature.buttons': 'Buttons',
  'feature.profiles': 'Profiles',
  'feature.battery': 'Battery',
  'feature.persistent': 'Onboard memory',

  // diagnostics
  'diag.title': 'Diagnostics',
  'diag.sub': 'Protocol log and HID layout of connected devices. Attach this to bug reports and device requests.',
  'diag.log': 'Protocol log',
  'diag.verbose': 'Show packets',
  'diag.copy': 'Copy report',
  'diag.download': 'Download log',
  'diag.clear': 'Clear',
  'diag.empty': 'Nothing logged yet.',
  'diag.collections': 'HID collections',
  'diag.copied': 'Copied to clipboard.',

  // settings
  'settings.title': 'Settings',
  'settings.sub': 'Preferences are saved in this browser only.',
  'settings.appearance': 'Appearance',
  'settings.theme': 'Theme',
  'settings.system': 'System',
  'settings.dark': 'Dark',
  'settings.light': 'Light',
  'settings.accent': 'Accent colour',
  'settings.language': 'Language',
  'settings.editing': 'Editing',
  'settings.autoApply': 'Apply automatically',
  'settings.autoApplyHint': 'Write each change to the mouse immediately instead of waiting for “Apply changes”.',
  'settings.about': 'About',
  'settings.aboutText': 'OpenGlide is free and open-source software released under the MIT licence.',
} as const;
